var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.tableOptions)?_c('x-data-table',{attrs:{"x-options":_vm.tableOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }